export default __webpack_public_path__ + "static/media/Highland_logo_white.e5b4f054.png";